import React, { FC } from "react";
import styled from "styled-components";  
import BlueSolidCard from "../../../../../images/cards/blue-solid.svg";
import BlueStripeCard from "../../../../../images/cards/blue-stripe.svg";
import GreenSolidCard from "../../../../../images/cards/green-solid.svg";
import GreenStripeCard from "../../../../../images/cards/green-stripe.svg"; 
import { CustomLabel, FlexContainer, InfoIcon, Input, theme } from "@mindmemobile/mm-shared-global";
import { DescriptionCell, LabelCell } from "../styles";

const { text, info } = theme.palette;
const DescriptionSection = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${text.light};
  .link {
    color: ${info.dark};
    padding-left: 5px;
    cursor: pointer;
  }
`;

type IProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  toggleShowExample: () => void;
  showExample?: boolean;
};
const ProductVariantRow: FC<IProps> = (props: IProps) => {
  const onClickShow = () => {
    props.toggleShowExample();
  };

  return (
    <FlexContainer>
      <LabelCell>
        <CustomLabel>Variants</CustomLabel>
        <InfoIcon />
      </LabelCell>
      <DescriptionCell>
        <FlexContainer spacing={50}>
          <div className="variant-section">
            <FlexContainer fxLayout="column" spacing={15}>
              <Input
                type="checkbox"
                label={"Create Variants by Attribute"}
                value={props.checked}
                onChange={(e) => props.onChange(e.target.checked)}
              />
              <DescriptionSection>
                Create variants of this item based on attributes like size,
                color, style, pattern, etc. Set price, cost, inventory on hand,
                SKU, images and more for each Variant.
                <span className="link" onClick={onClickShow}>
                  {props.showExample ? "Hide example." : "Show example."}
                </span>
              </DescriptionSection>
            </FlexContainer>
          </div>
          {props.showExample && (
            <div className="flex-auto-grow">
              <FlexContainer alignItems="center" spacing={15}>
                <div>
                  <img src={BlueSolidCard} />
                </div>
                <div>
                  <img src={BlueStripeCard} />
                </div>
                <div>
                  <img src={GreenSolidCard} />
                </div>
                <div>
                  <img src={GreenStripeCard} />
                </div>
              </FlexContainer>
            </div>
          )}
        </FlexContainer>
      </DescriptionCell>
    </FlexContainer>
  );
};

export default ProductVariantRow;
